/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {openCreditListUser} from '../../common/creditBill/actions';
import {deleteTable, closeShowTable, tableSave, tableMerge, prepareTableToPrint, closeTableToPrint,
    openDivideTables} from '../../common/tables/actions';
import CloseButton from '../components/buttons/CloseButton';
import {print, preparePrintArray, isNeedArrayPrint} from '../../common/lib/util';

class TablesControls extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        tableToPrint: React.PropTypes.object,
        bar: React.PropTypes.object,
        organization: React.PropTypes.object,
        orderToPrint: React.PropTypes.object,
        branch: React.PropTypes.object,
        deviceId: React.PropTypes.number,
        prepareTableToPrint: React.PropTypes.func,
        closeTableToPrint: React.PropTypes.func,
        deleteTable: React.PropTypes.func,
        tableMerge: React.PropTypes.func,
        openPaymentPopup: React.PropTypes.func,
        openCreditListUser: React.PropTypes.func,
        tableSave: React.PropTypes.func,
        closeShowTable: React.PropTypes.func,
        showTableId: React.PropTypes.string,
        tables: React.PropTypes.object,
        selectedProducts: React.PropTypes.object,
        printingInProgress: React.PropTypes.bool,
        silentPrint: React.PropTypes.bool,
        printType: React.PropTypes.string,
        printAddress: React.PropTypes.string,
        printLength: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.doOpenDividePopup = this.doOpenDividePopup.bind(this);
        this.printList = this.printList.bind(this);
        this.print = this.print.bind(this);
        this.openCreditListUser = this.openCreditListUser.bind(this);
    }

    openCreditListUser() {
        const {openCreditListUser, showTableId, tableSave, msg} = this.props;
        openCreditListUser(true, showTableId);
        tableSave(showTableId, msg);
    }

    doOpenDividePopup() {
        const {openDivideTables, tableMerge, showTableId, msg} = this.props;
        tableMerge(showTableId, msg);
        openDivideTables();
    }

    print() {
        const {
            closeTableToPrint, printType, bar, organization, branch, tableToPrint, deviceId, silentPrint, printAddress,
            printLength, msg
        } = this.props;

        const printArray = !!isNeedArrayPrint(printType)
            ? preparePrintArray(bar, organization, null, branch, null, tableToPrint, null, null, deviceId, msg, true)
            : null;

        print(printType, printAddress, printArray, silentPrint, printLength, false, null);
        setTimeout(function(){
            closeTableToPrint();
        }, 3500);
    }

    printList() {
        const {prepareTableToPrint} = this.props;
        prepareTableToPrint(true);

        const print = this.print;
        setTimeout(function(){
            print();
        }, 500);
    }

    render() {
        const {deleteTable, showTableId, closeShowTable, tables, tableSave, selectedProducts,
            printingInProgress, msg} = this.props;

        const productSize = !!showTableId
            ? !!tables.getIn([showTableId, 'products'])
                ? tables.getIn([showTableId, 'products']).size
                : 0
            : 0;
        const disabled = productSize === 0 && selectedProducts.size === 0;

        return (
            <section id="controls" className="controlPanel">
              <div className="controlPanel-box">
                <div className="boxBtn color-white text-l text-up" onClick={() => closeShowTable()}>
                    <CloseButton/>
                </div>
              </div>
                {productSize === 0 && !tables.getIn([showTableId, 'stable']) &&
                <div className="controlPanel-box">
                    <div className="boxBtn color-red text-l text-up" onClick={() => deleteTable(showTableId)}>
                        <div className="boxBtn-inner">
                            <span>{msg.global.delete}</span>
                        </div>
                    </div>
                </div>
                }
                {productSize === 0 && !!tables.getIn([showTableId, 'stable']) &&
                <div className="controlPanel-box">
                    <div className="boxBtn color-greenLight"/>
                </div>
                }
                {productSize !== 0 &&
                <div className="controlPanel-box">
                    <div className={`boxBtn color-green text-l text-up ${printingInProgress ? 'disabled' : ''}`}
                         onClick={() => this.printList()}>
                        <div className="boxBtn-inner">
                            <span>{msg.global.print}</span>
                        </div>
                    </div>
                </div>
                }
              <div className="controlPanel-box">
                <div className={`boxBtn color-green text-l text-up ${tables.getIn([showTableId, 'stable']) || !disabled ? '' : 'disabled'}`}
                     onClick={() => tableSave(showTableId, msg)}
                     disabled={disabled}>
                    <div className="boxBtn-inner">
                        <span>{msg.global.save}</span>
                    </div>
                </div>
              </div>
              <div className="controlPanel-box">
                <div className={`boxBtn color-green text-l text-up ${disabled ? 'disabled' : ''}`}
                     onClick={() => this.openCreditListUser()}
                     disabled={disabled}>
                    <div className="boxBtn-inner">
                        <span>{msg.homepage.controls.toBill}</span>
                    </div>
                </div>
              </div>
              <div className="controlPanel-box">
                <div className={`boxBtn color-red text-l text-up ${disabled ? 'disabled' : ''}`}
                     onClick={() => this.doOpenDividePopup()}
                     disabled={disabled}>
                    <div className="boxBtn-inner">
                        <span>{msg.homepage.controls.pay}</span>
                    </div>
                </div>
              </div>
            </section>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    tableToPrint: state.categories.get('tableToPrint'),
    organization: state.categories.get('organization'),
    orderToPrint: state.categories.get('orderToPrint'),
    bar: state.bars.get('bar'),
    branch: state.branches.get('branch'),
    deviceId: state.device.get('id'),
    showTableId: state.categories.get('showTableId'),
    tables: state.categories.get('tables'),
    selectedProducts: state.categories.get('selectedProducts'),
    silentPrint: state.device.get('silentPrint'),
    printType: state.device.get('printType'),
    printAddress: state.device.get('printAddress'),
    printingInProgress: state.categories.get('printingInProgress'),
    printLength: state.device.get('printLength')
}), {deleteTable, closeShowTable, tableSave, openDivideTables, tableMerge, prepareTableToPrint, openCreditListUser,
    closeTableToPrint})(TablesControls);



// WEBPACK FOOTER //
// ./src/browser/tables/TablesControls.js